import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef, } from 'react';
import { Form, Select, Tooltip } from 'antd';
import { HistoryOutlined } from '@ant-design/icons';
import { txt } from 'libs/i18n';
import { useSwitch } from 'hooks/useSwitch';
import AddItemButton from './AddItemButton';
import ItemWithActions from './ItemWithActions';
import SelectWithActionsModal from './SelectWithActionsModal';
import styles from './style.module.less';
const SelectWithActions = ({ fieldName, label, addLabel, editLabel, onClose, autoFocus = false, placeholder, options = [], fields, onAdd, onEdit, onDelete, allowStar = false, storeFullItem = false, rules, suggestedOptions = [], isSelectionStrict = false, autoOpenAddModal = false, }) => {
    var _a;
    const form = Form.useFormInstance();
    const [isModalOpen, openModal, closeModal] = useSwitch(false);
    const editingItemRef = useRef(null);
    useEffect(() => {
        var _a;
        const currentValue = form.getFieldValue(fieldName);
        if (options.length > 0 && currentValue === undefined) {
            const defaultItem = (_a = options.find((item) => item.isDefault)) !== null && _a !== void 0 ? _a : options[0];
            form.setFieldValue(fieldName, storeFullItem ? defaultItem : defaultItem.label);
        }
    }, [options, fieldName, storeFullItem, form]);
    useEffect(() => {
        if (autoOpenAddModal === true) {
            editingItemRef.current = null;
            openModal();
        }
    }, [autoOpenAddModal]);
    const handleOpenEditModal = useCallback((value) => {
        const item = options.find((i) => i.label === value);
        if (item) {
            editingItemRef.current = item;
            openModal();
        }
    }, [options, openModal]);
    const handleCloseModal = () => {
        editingItemRef.current = null;
        onClose === null || onClose === void 0 ? void 0 : onClose();
        closeModal();
    };
    const handleOpenAddModal = () => {
        editingItemRef.current = null;
        openModal();
    };
    const handleConfirm = (name, isDefault, values) => {
        const displayName = values !== undefined && Object.keys(values).length > 0
            ? Object.values(values).join(' ')
            : name;
        const updatedItem = { label: displayName, values, isDefault };
        if (editingItemRef.current !== null) {
            onEdit === null || onEdit === void 0 ? void 0 : onEdit(updatedItem, editingItemRef.current);
        }
        else {
            onAdd === null || onAdd === void 0 ? void 0 : onAdd(updatedItem);
        }
    };
    const getValueFromEvent = useCallback((value) => {
        if (value === '__add__') {
            return form.getFieldValue(fieldName);
        }
        if (storeFullItem && value !== '') {
            const selectedItem = options.find((item) => item.label === value);
            if (selectedItem) {
                return selectedItem;
            }
        }
        return value;
    }, [storeFullItem, options, form, fieldName]);
    const optionsWithActions = useMemo(() => [
        ...options.map((item) => ({
            label: (_jsx(ItemWithActions, { label: item.label, value: item.label, isStarred: allowStar && item.isDefault, icon: item.isFromDocument === true ? (_jsx(Tooltip, { title: txt('currentRole'), children: _jsx(HistoryOutlined, {}) })) : undefined, onEdit: handleOpenEditModal, onDelete: onDelete })),
            value: item.label,
        })),
        {
            label: _jsx(AddItemButton, { label: addLabel !== null && addLabel !== void 0 ? addLabel : txt('add'), onClick: handleOpenAddModal }),
            value: '__add__',
        },
    ], [options, handleOpenEditModal, onDelete, allowStar, addLabel]);
    return (_jsxs("div", { className: styles.formContainer, children: [_jsx(Form.Item, { name: fieldName, label: label, getValueFromEvent: getValueFromEvent, rules: rules, children: _jsx(Select, { options: optionsWithActions, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : label, allowClear: true, autoFocus: autoFocus }) }), _jsx(SelectWithActionsModal, { open: isModalOpen, onClose: handleCloseModal, onConfirm: handleConfirm, title: editingItemRef.current !== null ? (editLabel !== null && editLabel !== void 0 ? editLabel : txt('editLabel')) : (addLabel !== null && addLabel !== void 0 ? addLabel : txt('add')), nameLabel: label, initialValue: (_a = editingItemRef.current) !== null && _a !== void 0 ? _a : undefined, fields: fields, options: suggestedOptions, isSelectionStrict: isSelectionStrict })] }));
};
export default SelectWithActions;
